import { Component } from "react"
import { Outlet } from "react-router-dom"
import PropTypes from "prop-types"
import Modal from "components/modal"
import Nav from "./components/nav"
import SecurityProfile from "modules/security-profile"
import FactorProfile from "modules/factor-profile"
import Subnav from "./components/subnav"
import Notifications from "modules/notifications"
import Dialog from "modules/dialog"
import saveRecentResources from "hocs/saveRecentResources"
import "./style.scss"

class WatchlistRoot extends Component {
  static propTypes = {
    account: PropTypes.string.isRequired,
    watchlist: PropTypes.object.isRequired,
    selectedDate: PropTypes.string.isRequired,
    modelStartDate: PropTypes.string.isRequired,
    unmodeledDates: PropTypes.object.isRequired,
    modelEndDate: PropTypes.string.isRequired,
    setDate: PropTypes.func.isRequired,
    modelId: PropTypes.string.isRequired,
    security: PropTypes.object,
    closeSecurityProfile: PropTypes.func.isRequired,
    factorId: PropTypes.string,
    closeFactorProfile: PropTypes.func.isRequired,
    setModel: PropTypes.func.isRequired,
    sessionExpired: PropTypes.bool,
    menuItems: PropTypes.array,
    currency: PropTypes.string,
    unsupportedCurrencyWarning: PropTypes.string,
    modelIds: PropTypes.arrayOf(PropTypes.string),
    selectedModel: PropTypes.object,
  }

  render() {
    const {
      account,
      watchlist,
      modelId,
      security,
      closeSecurityProfile,
      factorId,
      closeFactorProfile,
      modelStartDate,
      modelEndDate,
      unmodeledDates,
      selectedDate,
      setDate,
      sessionExpired,
      menuItems,
      currency,
      unsupportedCurrencyWarning,
      modelIds,
      setModel,
      selectedModel,
    } = this.props

    return <div className="modules_watchlist-root">
      <Nav account={account} modelId={modelId} watchlistName={watchlist.name} menuItems={menuItems} />
      <Subnav modelId={modelId} modelName={selectedModel.name} setModel={setModel} unsupportedCurrencyWarning={unsupportedCurrencyWarning} modelIds={modelIds} />
      <div className="content">
        <div className="main">
          <div className="container-fluid">
            <Outlet context={{
              watchlist,
              modelId,
              modelStartDate,
              selectedDate,
              modelEndDate,
              unmodeledDates,
              setDate,
              currency,
            }}
            />
          </div>
        </div>
      </div>
      <Notifications />
      <Dialog />
      {security && <Modal superModalOpened={sessionExpired} onClose={closeSecurityProfile} className="modules_security-profile" noButton>
        <SecurityProfile security={security} modelId={modelId} onClose={closeSecurityProfile} />
      </Modal>}
      {factorId && <Modal superModalOpened={sessionExpired} onClose={closeFactorProfile} className="modules_factor-profile" noButton>
        <FactorProfile factorId={factorId} modelId={modelId} onClose={closeFactorProfile} />
      </Modal>}
    </div>
  }
}

export default saveRecentResources(WatchlistRoot, "watchlist.id")
